export default {
  apiKey: process.env.VUE_APP_YANDEX_MAP_API_KEY,
  suggestApiKey: process.env.VUE_APP_YMAP_SUGGEST_API_KEY,
  lang: 'ru_RU',
  coordorder: 'latlong',
  enterprise: false,
  version: '2.1'
}
